import Link from 'next/link';
import { Cable, Layers3, Pencil, Upload, Wrench } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { MarketingPageComposer } from './marketing-page-content-types';

const MENU_ICONS = {
  upload: Upload,
  references: Layers3,
  tools: Wrench,
  connectors: Cable,
  skills: Pencil,
} as const;

export function LandingComposerMenu({
  composer,
  children,
}: {
  composer: MarketingPageComposer;
  children: React.ReactNode;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent
        data-marketing-theme=""
        side="top"
        align="start"
        sideOffset={8}
        className="bg-marketing-bg border-marketing-border text-marketing-fg w-[min(22rem,calc(100vw-2rem))] rounded-lg border p-1.5 shadow-xl"
      >
        {composer.menuItems.map(({ id, label, description }) => {
          const Icon = MENU_ICONS[id];
          return (
            <DropdownMenuItem
              key={id}
              asChild
              className="text-marketing-fg focus:bg-marketing-surface focus:text-marketing-fg hover:bg-marketing-surface hover:text-marketing-fg group min-h-14 cursor-pointer rounded-md px-2.5 py-2 transition-colors"
            >
              <Link
                href={composer.href}
                className="flex w-full items-center gap-3"
              >
                <span className="border-marketing-border text-marketing-fg-muted group-hover:text-marketing-fg group-focus:text-marketing-fg flex size-8 shrink-0 items-center justify-center rounded-md border transition-colors">
                  <Icon
                    className="text-marketing-fg-muted group-hover:text-marketing-fg group-focus:text-marketing-fg size-4 transition-colors"
                    aria-hidden="true"
                  />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm leading-5 font-medium">
                    {label}
                  </span>
                  <span className="text-marketing-fg-muted block truncate text-xs leading-4">
                    {description}
                  </span>
                </span>
              </Link>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
